import React, { FC } from "react";

import LoginForm from "./LoginForm";
import { MagicPagesTypes } from "../../services/enums";
import useHttpGet from "../../hooks/useHttpGet";
import { IResultResponse } from "../../models/response/result.model";
import { IMagicPage } from "../../models/magic-page";
import { APIRoutes } from "../../http";
import CommonService from "../../services/common.service";
import AuthBase from "../AuthBase";

const LoginContainer: FC = () => {
  const { fetchedData, loading } = useHttpGet<IResultResponse<IMagicPage>>(
    `${APIRoutes.MAGIC_PAGES}/${MagicPagesTypes.Login}`,
    {
      defaultValue: {} as IResultResponse<IMagicPage>,
      reject: CommonService.showAllErrors,
    }
  );

  return (
    <AuthBase
      data={fetchedData?.result}
      loading={loading}
      title="Please log in"
    >
      <LoginForm />
    </AuthBase>
  );
};

export default LoginContainer;
